module.exports = __webpack_public_path__ + "resources/password-protected-group-d47aaeecd5e928b6584bdca3b0e855e4.svg";